import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { SubCategoryItem, CategoryItem } from 'src/app/request-v2/models/create-request.dto';
import { RequestLink } from 'src/app/request-v2/models/request.model';

@Component({
    selector: 'app-request-information',
    templateUrl: './request-information.component.html',
    styleUrls: ['./request-information.component.scss'],
})
export class RequestInformationComponent implements OnInit, OnChanges {
    @Input() selectedCategory: CategoryItem;

    @Input() selectedSubcategory: SubCategoryItem;

    @Input() initialDescription = '';

    @Input() initialFiles: File[] = [];

    @Input() initialLinks: RequestLink[] = [];

    @Output() requestInfoSubmitted = new EventEmitter<{ description: string; files: File[]; links: RequestLink[] }>();

    @Output() nextStep = new EventEmitter<void>();

    requestDescription = '';

    attachedFiles: File[] = [];

    requestLinks: RequestLink[] = [];

    wordCount = 0;

    maxWordCount = 300;

    maxFiles = 10;

    maxFileSizeMB = 20;

    acceptedFileTypes = 'image/*,.pdf,.doc,.docx,.xls,.xlsx';

    totalFileSize = 0;
    exceedsFileSizeLimit = false;

    ngOnInit(): void {
        this.initializeFormData();
    }

    initializeFormData(): void {
        if (this.initialDescription) {
            this.requestDescription = this.initialDescription;
            const words = this.requestDescription.trim().split(/\s+/);
            this.wordCount = this.requestDescription.trim() ? words.length : 0;
        }
        if (this.initialFiles && this.initialFiles.length > 0) {
            this.attachedFiles = [...this.initialFiles];
            this.calculateFileSizes();
        }
        this.requestLinks = [...(this.initialLinks || [])];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.initialDescription && !changes.initialDescription.firstChange) {
            this.requestDescription = this.initialDescription;
            const words = this.requestDescription.trim().split(/\s+/);
            this.wordCount = this.requestDescription.trim() ? words.length : 0;
        }

        if (changes.initialLinks && !changes.initialLinks.firstChange) {
            this.requestLinks = [...(this.initialLinks || [])];
        }
    }

    onDescriptionChange(value: string): void {
        if (typeof value === 'string') {
            const text = value || '';
            const words = text.trim().split(/\s+/);
            this.wordCount = text.trim() ? words.length : 0;
        }
    }

    onAttachedFilesChanged(files: File[]): void {
        this.attachedFiles = files;
        this.calculateFileSizes();
    }

    onRequestLinksChanged(links: RequestLink[]): void {
        this.requestLinks = [...links];
    }

    calculateFileSizes(): void {
        this.totalFileSize = 0;

        this.attachedFiles.forEach((file) => {
            const fileSizeMB = file.size / (1024 * 1024);
            this.totalFileSize += fileSizeMB;
        });

        this.exceedsFileSizeLimit = this.totalFileSize > this.maxFileSizeMB;
    }

    isDescriptionInvalid(): boolean {
        return this.requestDescription.trim() === '' || this.wordCount > this.maxWordCount;
    }

    isFormValid(): boolean {
        return !this.isDescriptionInvalid() && !this.exceedsFileSizeLimit;
    }

    goToNextStep(): void {
        if (!this.isFormValid()) {
            return;
        }

        const requestInfo = {
            description: this.requestDescription,
            files: this.attachedFiles,
            links: this.requestLinks,
        };
        this.requestInfoSubmitted.emit(requestInfo);
        this.nextStep.emit();
    }

    resetForm(): void {
        this.requestDescription = '';
        this.attachedFiles = [];
        this.requestLinks = [];
        this.wordCount = 0;
        this.totalFileSize = 0;
        this.exceedsFileSizeLimit = false;
        this.initialFiles = [];
        this.initialLinks = [];
    }
}
